import { GrowthRateBasisType, ReferenceData } from '@xplan-pension-switching/common';
import { useIndustryStandardRows } from '../UseIndustryStandardRows/UseIndustryStandardRows';
import { useFundSpecificNominalRows } from '../UseFundSpecificNominalRows/UseFundSpecificNominalRows';
import { useInflationAdjustedRows } from '../UseInflationRateAdjustedRows/UseInflationRateAdjustedRows';

export const useGrowthRateTableData = (
    selectedGrowthRateBasisType: GrowthRateBasisType,
    referenceData: ReferenceData,
    defaultGrowthRateBasisType: GrowthRateBasisType,
    growthRateLow?: number,
    growthRateMid?: number,
    growthRateHigh?: number
) => {
    const industryStandardRows = useIndustryStandardRows(referenceData, selectedGrowthRateBasisType);
    const fundSpecificNominalRows = useFundSpecificNominalRows({
        growthRateLow,
        growthRateMid,
        growthRateHigh,
        referenceData,
        selectedGrowthRateBasisType,
        defaultGrowthRateBasisType,
    });
    const fundSpecificInflationRows = useInflationAdjustedRows({
        growthRateLow,
        growthRateMid,
        growthRateHigh,
        referenceData,
        selectedGrowthRateBasisType,
        defaultGrowthRateBasisType,
    });
    if (selectedGrowthRateBasisType === GrowthRateBasisType.IndustryStandard) {
        return { rowData: industryStandardRows };
    }
    if (selectedGrowthRateBasisType === GrowthRateBasisType.FundSpecificNominal) {
        return { rowData: fundSpecificNominalRows };
    }
    if (selectedGrowthRateBasisType === GrowthRateBasisType.FundSpecificInflation) {
        return { rowData: fundSpecificInflationRows };
    }

    return { rowData: null };
};
